import React from 'react'
import PropTypes from 'prop-types'

import css from './noteEditor.css'

const NoteEditor = ({ value, onChange, onSave, onCancel, onDelete, isNew }) => (
  <div className={css.container}>
    <textarea
      placeholder="Type your note here"
      value={value}
      onChange={onChange}

    />
    <div className={css.buttons}>
      <button
        className={css.buttonSave}
        onClick={onSave}
        disabled={!value}
      >
        Save
      </button>
      <button
        onClick={onCancel}
        className={css.buttonCancel}
      >
        Cancel
      </button>
      {!isNew &&
        <button
          onClick={onDelete}
          className={css.buttonDelete}
        >
          Delete
        </button>
      }
    </div>
  </div>

)
NoteEditor.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isNew: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
}
export default NoteEditor



// WEBPACK FOOTER //
// ./src/components/PatientPage/Notes/NoteEditor.js